import { createTheme } from '@material-ui/core/styles';

const portalTheme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: 'Porsche Next !important',
    },

    palette: {
        primary: {
            main: '#1C1C1C',
        },

        secondary: {
            main: '#D5001C',
            contrastText: '#fff',
        },
    },
});

export default portalTheme;
